export default __webpack_public_path__ + "static/media/logo_eurostar.f578da07.svg";